module.exports = __webpack_public_path__ + "media/images/icons/material/calendar-black-bb7c4a116cabb07886570d066e426c6c.svg";